import { StarknetWindowObject } from 'starknetkit';
import { Nullable } from '../../interfaces';
import { createAsyncAtom } from '../../lib/state';

const walletAtom = createAsyncAtom<Nullable<StarknetWindowObject>>(async () => null);

export default walletAtom;
